import { useRouter } from 'next/router';
import { extractParametersFromUrl, isEpisodePage as pageIsInEpisodeMode } from '@/helpers/pages/channel';

const useShowUrlParams = () => {
  const { query } = useRouter();
  const {
    slug: showSlug,
    episodeNumber,
    seasonNumber
  } = extractParametersFromUrl({ query });

  return {
    showSlug,
    episodeNumber,
    seasonNumber,
    isEpisodePage: pageIsInEpisodeMode({ query })
  };
};

export default useShowUrlParams;